<div class="card mb-5">
  <div class="card-header border-0">
    <div class="row gy-2 justify-content-between">
      <div class="col-auto col-sm-6 col-md-auto">
        <span class="text-muted small">
          {{ "LESSONS.ROOM_DETAILS.PLANNED_TO_START" | translate }}
          {{ getLessonDate() | dateTranslation : "dd MMM yyyy HH:mm" }}
        </span>
        <p class="text-muted small mb-0">
          <span *ngIf="!isProva()">{{ getCourseName() }}</span>
          <span *ngIf="isProva()">
            <span>{{ getCourseLangName() | translate }}</span>
            <span>{{ "COL.LESSONS.DETAILS.PROVA.LEVEL_TEST" | translate }}</span>
          </span>
          -
          <span>{{ getStatusDescription() | translate }}</span>
        </p>
      </div>
      <div *ngIf="cancelable || (cancelable && isComing)" class="col-auto ms-sm-auto">
        <button type="button" class="btn btn-primary rounded-pill py-2"
                (click)="cancelLessonModal.show()">
          {{ 'BUTTON.CANCEL_LESSON' | translate }}
        </button>
      </div>
      <div class="col-auto ms-auto ms-sm-0">
        <button
          type="button"
          class="btn btn-outline-primary question-mark-container rounded-pill px-2"
          (click)="howToEnterModal.show()"
        >
          <app-icon name="question-mark" class="icon-blue"></app-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <ng-container class="mb-4">
      <div class="bg-blue rounded-3 p-3 py-md-4">
        <div class="row flex-sm-row flex-column justify-content-sm-between gy-3">
          <div class="col-12 col-sm-auto d-flex align-items-center">
            <div
              *ngIf="getLessonTeacherPhotoUrl()"
              class="profile-photo rounded-circle initials-circle me-2"
              [style.background-image]="'url(' + getLessonTeacherPhotoUrl() + ')'"
            ></div>
            <div
              *ngIf="!getLessonTeacherPhotoUrl()"
              class="d-flex rounded-circle text-center bg-black initials-circle me-2"
            >
                <span class="text-muted m-auto">
                  {{ getInitials() }}
                </span>
            </div>
            <div class="my-auto">
              <p class="text-muted xsmall mb-0">
                {{ "LESSONS.ROOM_DETAILS.TEACHER" | translate }}
              </p>
              <p class="small mb-0">{{ getTeacherName() }}</p>
            </div>
          </div>
          <div class="col-12 col-sm-auto d-flex flex-column text-center gap-2">
            <div *ngIf="isLessonGoingToStartRegularly()">
              <span>
                <span>{{ "COL.COURSES.COMING_LESSON.WILL_START" | translate }}</span><br>
                <strong class="text-success">{{ timePhrase }}</strong>
              </span>
            </div>
            <div *ngIf="isTeacherMissingToStartLesson()">
              <span>
                <span>{{ "COL.COURSES.COMING_LESSON.WAITING_FOR_TEACHER" | translate }}</span><br/>
                <strong class="text-danger">{{ timePhrase }}</strong>
              </span>
            </div>
            <div class="d-flex h-100">
              <div class="m-sm-auto w-100">
                <div class="row flex-column">
                  <div class="text-lg-right" *ngIf="mayEnterVideoRoom()">
                    <a class="btn btn-primary rounded-pill w-100 mb-1 mb-sm-0"
                       target="_blank"
                       tabindex=""
                       [href]="getRoomUrl()"
                    >
                      {{ "COL.COURSES.COMING_LESSON.ENTER_ROOM" | translate }}
                    </a>
                    <button class="d-sm-none btn btn-outline-primary rounded-pill w-100"
                            (click)="copyToClipboard()"
                    >
                      {{ getMobileCopyButtonText() | translate }}
                    </button>
                    <div
                      id="copyTooltip"
                      class="cursor-pointer d-none d-sm-block"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      data-bs-title=" "
                      (click)="copyToClipboard()"
                    >
                      <u>
                        {{ "LESSONS.ROOM_DETAILS.OR_COPY_LINK" | translate }}
                      </u>
                    </div>
                  </div>
                  <div class="text-lg-right" *ngIf="mayEnterRoomBySkype()">
                    <a
                      class="btn btn-primary rounded-pill"
                      [href]="getRoomUrl()"
                      tabindex=""
                    >{{ "BUTTON.CALL_SKYPE" | translate }}</a>
                    <a
                      (click)="moveToInstructions()"
                      tabindex=""
                      class="d-block"
                      target="_blank"
                    ><small>{{ "COL.COURSES.COMING_LESSON.WHAT_NOW" | translate }}</small></a>
                  </div>
                  <span
                    class="text-muted"
                    *ngIf="!mayEnterClassroom() && !isFuture()"
                    tabindex=""
                  >
                    <span>{{ "COL.COURSES.COMING_LESSON.ROOM_CLOSED" | translate }}</span>
                  </span>
                  <div *ngIf="!mayEnterClassroom() && isFuture()">
                    <div
                      id="lessonNotStartedTooltip"
                      class="cursor-pointer"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="{{ 'COL.COURSES.COMING_LESSON.LESSON_NOT_STARTED' | translate }}"
                    >
                      <button class="btn btn-primary rounded-pill" disabled>
                        {{ "BUTTON.ENTER_LESSON" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="isProva()" class="mt-3">
      <h5 class="text-primary">
        {{ "COL.LESSONS.DETAILS.PROVA.WHILE_YOU_WAIT.TITLE" | translate }}
      </h5>
      <ng-container *ngIf="isKidsEnglish(); else adultWhileYouWait">
        <p>
          {{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_DESCRIPTION" | translate }}
        </p>
        <ul>
          <li>{{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_BULLET_1" | translate }}</li>
          <li>{{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_BULLET_2" | translate }}</li>
          <li>{{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_BULLET_3" | translate }}</li>
          <li>{{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_BULLET_4" | translate }}</li>
        </ul>
        <p>
          {{ "COL.LESSONS.DETAILS.PROVA.KDS.WHILE_YOU_WAIT_FOOTER" | translate }}
        </p>
      </ng-container>
      <ng-template #adultWhileYouWait>
        <p>
          {{ "COL.LESSONS.DETAILS.PROVA.WHILE_YOU_WAIT.DESCRIPTION" | translate }}
        </p>
        <h5 class="text-primary">
          {{ "COL.LESSONS.DETAILS.PROVA.HOW_CALLAN_WORKS" | translate }}
        </h5>
        <ng-container *ngIf="isWebMSupported; else noSupport">
          <div class="ratio ratio-16x9">
            <video controls>
              <source [src]="provaVideoUrl" type="video/webm"/>
            </video>
          </div>
        </ng-container>
        <ng-template #noSupport>
          <div class="d-flex text-center justify-content-center align-items-center webm-not-supported-container p-5">
            <span>{{ "COL.LESSONS.DETAILS.VIDEO_FORMAT_NOT_SUPPORTED" | translate }}
              <a [href]='provaVideoYouTubeUrl' target='_blank'>
                <u>{{ "COL.LESSONS.DETAILS.WATCH_VIDEO" | translate }}</u>
              </a>.</span>
          </div>
        </ng-template>
      </ng-template>
    </div>
    <div *ngIf="!isKidsEnglish()" class="mt-3 mb-4 d-flex flex-column align-items-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-quiz.svg" height="89" width="88"/>
      <h5 class="text-primary px-5 mx-sm-5 my-3 text-center">
        {{ "COL.LESSONS.DETAILS.PROVA.DO_FUN_QUIZ" | translate }}
      </h5>
      <button type="button" class="btn btn-primary rounded-pill px-3" (click)="callanMethodQuizModal.open()">
        {{ "BUTTON.TAKE_QUIZ" | translate }}
      </button>
    </div>
    <div *ngIf="!isFinished() && isProva()">
      <ng-container *ngIf="isKidsEnglish(); else adultLessonPlan">
        <h5 class="text-primary">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_PROVA_TITLE" | translate }}
        </h5>
        <p class="prova-body" [innerHTML]="'COL.LESSONS.DETAILS.LESSON_PLAN.KDS_PROVA_BODY' | translate"></p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_HOW_TO_ANSWER.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_HOW_TO_ANSWER.CONTENT_1" | translate }}
          <br>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_HOW_TO_ANSWER.CONTENT_2" | translate }}
        </p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_EXAMPLE.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_EXAMPLE.LINE_1" | translate }}
          <span class="fst-italic">Is the pen short?</span><br>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_EXAMPLE.LINE_2" | translate }}
          <span class="fst-italic">No, the pen isn't short; it's long.</span>
        </p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_AT_THE_END.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.KDS_AT_THE_END.CONTENT" | translate }}
        </p>
      </ng-container>
      <ng-template #adultLessonPlan>
        <h5 class="text-primary">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.TITLE" | translate }}
        </h5>
        <p *ngIf="isEnglishCore()" class="prova-body" [innerHTML]="'COL.LESSONS.DETAILS.LESSON_PLAN.EN_PROVA_BODY' | translate"></p>
        <p *ngIf="isSpanish()" class="prova-body" [innerHTML]="'COL.LESSONS.DETAILS.LESSON_PLAN.ES_PROVA_BODY' | translate"></p>
        <p *ngIf="isBusiness()" class="prova-body" [innerHTML]="'COL.LESSONS.DETAILS.LESSON_PLAN.BS_PROVA_BODY' | translate"></p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.HOW_TO_ANSWER.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.HOW_TO_ANSWER.CONTENT" | translate }}
        </p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.EXAMPLE.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.EXAMPLE.LINE_1" | translate }}
          <span class="fst-italic">Is the chair high?</span><br>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.EXAMPLE.LINE_2" | translate }}
          <span class="fst-italic">No.</span><br>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.EXAMPLE.LINE_3" | translate }}
          <span class="fst-italic">No, the chair isn't high, it's low.</span>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.EXAMPLE.LINE_3_CONTINUE" | translate }}
        </p>
        <div class="fw-bold">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.AT_THE_END.TITLE" | translate }}
        </div>
        <p>
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.AT_THE_END.CONTENT" | translate }}
        </p>
        <div class="mt-3 mb-4 d-flex flex-column align-items-center">
          <img class="m-3" ngSrc="../../../assets/pre-prova-quiz.svg" height="89" width="88"/>
          <h5 class="text-primary px-5 mx-sm-5 my-3 text-center">
            {{ "COL.LESSONS.DETAILS.PROVA.WHAT_TO_EXPECT" | translate }}
          </h5>
          <button type="button" class="btn btn-primary rounded-pill px-3" (click)="levelTestQuizModal.open()">
            {{ "BUTTON.TAKE_QUIZ" | translate }}
          </button>
        </div>
      </ng-template>
    </div>

    <!-- !(invalidated || cancelled ) && !studentNoShow -->
    <div
      *ngIf="!(isInvalidated() || isCancelled()) && !isStudentNoShow()"
      class="mb-4"
    >
      <ng-container *ngIf="!isProva()">
        <h5 class="text-primary">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.TITLE" | translate }}
        </h5>
        <!-- future && mt 12 && !next -->
        <p *ngIf="isFuture() && !isClose()">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.HIDDEN_FOR_LATE" | translate }}
        </p>
        <!-- future && lt 12 && !next-->
        <p *ngIf="isFuture() && isClose() && !isNext()">
          {{ "COL.LESSONS.DETAILS.LESSON_PLAN.HIDDEN_FOR_NOT_NEXT" | translate }}
        </p>
        <!-- (isClose && isNext) || (!isFuture && !isComplete) -->
        <div *ngIf="(isClose() && isNext()) || (!isFuture() && !isComplete())">
          <div class="row mb-3" *ngIf="progress">
            <div class="col-12 col-lg-8 col-xl-6 col-xxl-4">
              <p class="mb-2">
                <span>{{ "COL.LESSONS.DETAILS.LESSON_PLAN.START_PAGE" | translate }}</span>
                <span class="float-end">{{ progress.start }}</span>
              </p>
              <p class="mb-2">
                <span>{{ "COL.LESSONS.DETAILS.LESSON_PLAN.NEW_WORK_PAGE" | translate }}</span>
                <span class="float-end">{{ progress.nwp }}</span>
              </p>
              <p class="mb-0">
                <span>{{ "COL.LESSONS.DETAILS.LESSON_PLAN.READING_START_PAGE" | translate }}</span>
                <span class="float-end">{{ getRecommendedReading() }}</span>
              </p>
            </div>
          </div>
          <p>
            {{ "COL.LESSONS.DETAILS.LESSON_PLAN.MAY_BE_MODIFIED" | translate }}
          </p>
        </div>
      </ng-container>
      <!-- complete && !studentNoShow -->
      <div *ngIf="isComplete() && !isStudentNoShow()">
        <div class="row mb-3" *ngIf="committedProgress">
          <div class="col-12 col-lg-8 col-xl-6 col-xxl-4">
            <p class="mb-2">
              <span>{{ "COL.LESSONS.DETAILS.LAST_PROGRESS.REVISION_START_PAGE" | translate }}</span>
              <span class="float-end">{{ committedProgress.start }}</span>
            </p>
            <p class="mb-2">
              <span>{{ "COL.LESSONS.DETAILS.LAST_PROGRESS.NEW_WORK_PAGE" | translate }}</span>
              <span class="float-end">{{ committedProgress.nwp }}</span>
            </p>
            <p class="mb-2">
              <span>{{ "COL.LESSONS.DETAILS.LAST_PROGRESS.LAST_WORD" | translate }}</span>
              <span class="float-end">{{ committedProgress.headwords }}</span>
            </p>
            <p class="mb-0">
              <span>{{ "COL.LESSONS.DETAILS.LAST_PROGRESS.READING_PAGE" | translate }}</span>
              <span class="float-end">{{ committedProgress.reading }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- (!finished && !inProgress) || cancelled - to reduce -->
    <div *ngIf="!(isFinished() || isInProgress()) || isCancelled()">
      <h5 class="text-primary">
        {{ (isKidsEnglish() ? 'COL.LESSONS.DETAILS.CANCELLATION.KDS_TITLE' : 'COL.LESSONS.DETAILS.CANCELLATION.TITLE') | translate }}
      </h5>
      <!-- future && mt 12  -->
      <p *ngIf="isFuture() && !isClose() && !isCancelled()">
        {{ (isKidsEnglish() ? 'COL.LESSONS.DETAILS.CANCELLATION.KDS_ALLOWED' : 'COL.LESSONS.DETAILS.CANCELLATION.ALLOWED') | translate }}
      </p>
      <!-- !finished && lt 12 !inProgress -->
      <p *ngIf="isClose() && !isCancelled()">
        {{ 'COL.LESSONS.DETAILS.CANCELLATION.NOT_ALLOWED' | translate }}
      </p>
      <div *ngIf="isCancelled() && !hasCancellationDetails()">
        <p>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_NO_REASON.CONTENT_1' | translate }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_NO_REASON.CONTENT_2' | translate }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_NO_REASON.CONTENT_3' | translate }}</p>
      </div>
      <!-- cancelled && byStudent-->
      <div *ngIf="isCancelled() && hasCancellationDetails() && isByStudent()">
        <p>
         {{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED.CONTENT_1' | translate }}
        </p>
        <p><strong>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED.CONTENT_2' | translate }}</strong> {{ getCancellationReason() }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED.CONTENT_3' | translate }}</p>
      </div>
      <!-- cancelled && byTutor -->
      <div *ngIf="isCancelled() && hasCancellationDetails() && !isByStudent()">
        <p>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_BY_TEACHER.CONTENT_1' | translate }}</p>
        <p><strong>{{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_BY_TEACHER.CONTENT_2' | translate }}</strong> {{ getCancellationReason() }}</p>
        <p>
          {{ 'COL.LESSONS.DETAILS.CANCELLATION.LESSON_CANCELLED_BY_TEACHER.CONTENT_3' | translate }}
        </p>
      </div>
    </div>
    <!-- complete && !studentNoShow -->
    <div *ngIf="isComplete() && !isStudentNoShow() && getMessage()">
      <h5 class="text-primary">{{ 'COL.LESSONS.DETAILS.COMPLETE.MESSAGE' | translate }}</h5>
      <p>
        {{ getMessage() }}
      </p>
    </div>
    <!-- (complete && studentNoShow) || (invalidated && tutorNoShow) -->
    <div
      *ngIf="
        (isComplete() && isStudentNoShow()) ||
        (isInvalidated() && isTutorNoShow())
      "
    >
      <h5 class="text-primary">{{ 'COL.LESSONS.DETAILS.LESSON.TITLE' | translate }}</h5>
      <!-- invalidated && tutorNoShow-->
      <div *ngIf="isInvalidated() && isTutorNoShow()">
        <p>{{ 'COL.LESSONS.DETAILS.LESSON.TUTOR_NO_SHOW.CONTENT_1' | translate }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.LESSON.TUTOR_NO_SHOW.CONTENT_2' | translate }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.LESSON.TUTOR_NO_SHOW.CONTENT_3' | translate }}</p>
      </div>
      <!-- complete && studentNoShow -->
      <div *ngIf="isComplete() && isStudentNoShow()">
        <p>{{ 'COL.LESSONS.DETAILS.LESSON.STUDENT_NO_SHOW.CONTENT_1' | translate }}</p>
        <p>{{ 'COL.LESSONS.DETAILS.LESSON.STUDENT_NO_SHOW.CONTENT_2' | translate }}</p>
        <p>
          {{ 'COL.LESSONS.DETAILS.LESSON.STUDENT_NO_SHOW.CONTENT_3' | translate }}
        </p>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-primary rounded-pill px-3" (click)="contactUsModal.open()">
        {{ "NAVIGATION.CONTACT_US" | translate }}
      </button>
    </div>
  </div>
</div>
<app-modal #classroomFallback>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">
        {{ "COL.COURSES.COMING_LESSON.CONNECTION_PROBLEMS" | translate }}
      </h5>
      <button type="button" class="btn-close" (click)="classroomFallback.hide()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <p>
        <span>{{ "COL.COURSES.COMING_LESSON.ABOUT_REFRESH" | translate }}</span>
        <i class="fas fa-redo ms-2"></i>
      </p>
      <p>
        <span>
          {{ "COL.COURSES.COMING_LESSON.ABOUT_TEACHER_SKYPE" | translate }}
        </span>
        <a class="ms-2" [href]="getTeacherSkypeUrl()" >
          {{getTeacherSkype()}}
        </a>
      </p>
      <div class="text-end">
        <button type="button" class="btn btn-primary rounded-pill" (click)="classroomFallback.hide()">
          {{ "BUTTON.OK" | translate }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
<app-modal #cancelLessonModal>
  <div class="modal-content" *ngIf="_lesson">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ 'COL.TEACHER.MODAL.CANCEL_LESSON.TITLE' | translate }}</h5>
      <button
        type="button"
        class="btn-close"
        (click)="cancelLessonModal.hide()"
        aria-label="Close"
      ></button>
    </div>
    <form #f="ngForm" (ngSubmit)="f.valid && cancelLesson()">
      <div class="modal-body">
        <p>{{ 'COL.TEACHER.MODAL.CANCEL_LESSON.INFO_STUDENT' | translate }}</p>
        <p
          *ngIf="_lesson.status == LessonStatus.Due || shouldStart"
          class="text-danger fw-bold"
        >
          {{ 'COL.TEACHER.MODAL.CANCEL_LESSON.INFO_DUE' | translate }}
        </p>
        <div class="row">
          <div class="col-12">
            <div class="form-floating">
              <textarea
                id="reason"
                #reason="ngModel"
                name="reason"
                placeholder="reason"
                class="form-control textarea-height"
                required
                [maxlength]="cancelReasonMaxLength"
                [(ngModel)]="cancelReason"
                [ngClass]="{ 'is-invalid': f.submitted && reason.invalid }"
              ></textarea>
              <label for="reason">{{ 'COL.TEACHER.MODAL.CANCEL_LESSON.REASON' | translate }}</label>
              <div
                *ngIf="f.submitted && reason.invalid"
                class="invalid-feedback"
              >
                <div *ngIf="reason.errors?.['required']">
                  {{ 'FORM_ERROR.FIELD_REQUIRED' | translate }}
                </div>
              </div>
            </div>
            <div class="form-text text-end">{{ cancelReason?.length || 0 }} / {{ cancelReasonMaxLength }}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button type="submit" class="btn btn-danger rounded-pill">
          {{ 'BUTTON.CANCEL_LESSON' | translate }}
        </button>
      </div>
    </form>
  </div>
</app-modal>
<app-modal #howToEnterModal>
  <div class="modal-content top-0">
    <div class="modal-header border-0">
      <h5 class="modal-title">{{ "COL.LESSONS.HOW_TO_JOIN_LESSON.MODAL.TITLE" | translate }}</h5>
      <button type="button"
              class="btn btn-close btn-close-white"
              (click)="howToEnterModal.hide()"
              aria-label="Close">
      </button>
    </div>
    <div class="modal-body">
      <span class=" mb-2" [innerHTML]="htmlContent"></span>
    </div>
  </div>
</app-modal>
<app-contact-us-modal #contactUsModal></app-contact-us-modal>
<app-pre-prova-quiz #callanMethodQuizModal quizName="CALLAN_METHOD"></app-pre-prova-quiz>
<app-pre-prova-quiz #levelTestQuizModal quizName="LEVEL_TEST"></app-pre-prova-quiz>
